import { render, staticRenderFns } from "./TouchScreenConfig.vue?vue&type=template&id=531c8de0&"
import script from "./TouchScreenConfig.vue?vue&type=script&lang=ts&"
export * from "./TouchScreenConfig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports